"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetResponseT = exports.ResetResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const reset_status_js_1 = require("../../solarxr-protocol/rpc/reset-status.js");
const reset_type_js_1 = require("../../solarxr-protocol/rpc/reset-type.js");
class ResetResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsResetResponse(bb, obj) {
        return (obj || new ResetResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsResetResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ResetResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    resetType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : reset_type_js_1.ResetType.Yaw;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : reset_status_js_1.ResetStatus.STARTED;
    }
    /**
     * Should return the body parts reseted / being reset
     */
    bodyParts(index) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    bodyPartsLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    bodyPartsArray() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    /**
     * gives the time in seconds passed since the start of the reset
     * is 0 when status == FINISHED
     * starts at 0
     */
    progress() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
    }
    duration() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
    }
    static startResetResponse(builder) {
        builder.startObject(5);
    }
    static addResetType(builder, resetType) {
        builder.addFieldInt8(0, resetType, reset_type_js_1.ResetType.Yaw);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(1, status, reset_status_js_1.ResetStatus.STARTED);
    }
    static addBodyParts(builder, bodyPartsOffset) {
        builder.addFieldOffset(2, bodyPartsOffset, 0);
    }
    static createBodyPartsVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startBodyPartsVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addProgress(builder, progress) {
        builder.addFieldInt32(3, progress, 0);
    }
    static addDuration(builder, duration) {
        builder.addFieldInt32(4, duration, 0);
    }
    static endResetResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createResetResponse(builder, resetType, status, bodyPartsOffset, progress, duration) {
        ResetResponse.startResetResponse(builder);
        ResetResponse.addResetType(builder, resetType);
        ResetResponse.addStatus(builder, status);
        ResetResponse.addBodyParts(builder, bodyPartsOffset);
        ResetResponse.addProgress(builder, progress);
        ResetResponse.addDuration(builder, duration);
        return ResetResponse.endResetResponse(builder);
    }
    unpack() {
        return new ResetResponseT(this.resetType(), this.status(), this.bb.createScalarList(this.bodyParts.bind(this), this.bodyPartsLength()), this.progress(), this.duration());
    }
    unpackTo(_o) {
        _o.resetType = this.resetType();
        _o.status = this.status();
        _o.bodyParts = this.bb.createScalarList(this.bodyParts.bind(this), this.bodyPartsLength());
        _o.progress = this.progress();
        _o.duration = this.duration();
    }
}
exports.ResetResponse = ResetResponse;
class ResetResponseT {
    constructor(resetType = reset_type_js_1.ResetType.Yaw, status = reset_status_js_1.ResetStatus.STARTED, bodyParts = [], progress = 0, duration = 0) {
        this.resetType = resetType;
        this.status = status;
        this.bodyParts = bodyParts;
        this.progress = progress;
        this.duration = duration;
    }
    pack(builder) {
        const bodyParts = ResetResponse.createBodyPartsVector(builder, this.bodyParts);
        return ResetResponse.createResetResponse(builder, this.resetType, this.status, bodyParts, this.progress, this.duration);
    }
}
exports.ResetResponseT = ResetResponseT;
